import BuilderTabs from "../../Layouts/BuilderTabs";
import React, { useEffect, useState } from "react";
import Input from "../FormComponents/Input";
import SingleSelectBox from "../FormComponents/SingleSelectBox";
import { useTableContext } from "../../context/TableContext";
import { CustomColumnGroupData } from "../../Pages/ApplicationBlock/RecordsViewRenderer/Desktop/RecordsViewEdit/Columns/EditCustomColumn";
import BuilderModal from "../../Layouts/Modal/BuilderModal";
import TableTreeModal from "../BuilderComponents/TableTreeModal";
import { useAppBlocksContext } from "../../context/AppBlocksContext";
import { ButtonListEditor } from "./EditButtonGroup";

const EditCustomColumn = ({ column, handleChangeColumn, tableId, tableType, device = "desktop" }) => {
  const handleChange = (name, value) => {
    handleChangeColumn({ ...column, [name]: value });
  };

  const tabData = [
    {
      label: "Label",
      content: <CommonEditFieldForCustomColumn handleChange={handleChange} column={column} />
    },
    {
      label: "Config",
      content: <EditCustomColumnByType {...{ column, handleChangeColumn, tableId, tableType, device }} />
    }
  ];

  return <BuilderTabs tabs={tabData} contentClass="tab-content-scroll" />;
};

function CommonEditFieldForCustomColumn({ handleChange, column }) {
  return (
    <div className="builder_form p_3" style={{ height: "500px" }}>
      <Input
        label="Column Label"
        onChange={(e) => handleChange(e.target.name, e.target.value)}
        name="display"
        value={column?.display || ""}
      />
      <SingleSelectBox
        selectedData={column?.width_type || ""}
        options={widthOptions}
        onChange={(obj) => handleChange("width_type", obj.id)}
        placeholder="select"
        label="Select width type"
      />
      {column?.width_type && (
        <>
          <Input
            label="Width(in pixels)"
            type="number"
            name="width_value"
            onChange={(e) => handleChange(e.target.name, e.target.value)}
            value={column?.width_value || ""}
          />
        </>
      )}
    </div>
  );
}

const EditCustomColumnByType = ({ column, handleChangeColumn, tableId, tableType, device }) => {
  // EditButtonGroup;
  switch (column.custom_type) {
    case "button":
      return <EditButtonCustomColumn {...{ column, handleChangeColumn, tableId, tableType, device }} />;
    case "aggregate_column":
      return <EditAggregateCustomColumn {...{ column, handleChangeColumn, tableId, tableType }} />;
    default:
      return null;
  }
};

const widthOptions = [
  { id: "width", name: "width" },
  { id: "max_width", name: "max width" },
  { id: "min_width", name: "min width" }
];

const aggregateFunctionOptions = [
  { id: "", name: "none" },
  { id: "sum", name: "sum" },
  { id: "count", name: "count" },
  { id: "count_if", name: "count if" }
];
const EditAggregateCustomColumn = ({ column, handleChangeColumn, tableId, tableType }) => {
  const [tableObj, setTableObj] = useState({});
  const { getTableTypeData } = useTableContext();
  const initialModalState = {
    show: false,
    type: "",
    name: ""
  };
  const [isModalOpen, setIsModalOpen] = useState(initialModalState);

  const closeModal = () => {
    setIsModalOpen(initialModalState);
  };

  const handleChange = (name, value) => {
    handleChangeColumn({ ...column, [name]: value });
  };

  const handleAggrigateColumn = (data) => {
    const copyObj = { ...column };
    copyObj.aggregate_column = data.id;
    handleChangeColumn(copyObj);
    closeModal();
  };

  const handleChangeInAggrigateFunction = (data) => {
    handleChangeColumn(data);
  };

  useEffect(() => {
    const fetchTable = async () => {
      let { tableObject } = await getTableTypeData(tableType, tableId);
      setTableObj(tableObject);
    };
    fetchTable();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="builder_form p_3" style={{ height: "500px" }}>
      <div className="flex_column gap_1">
        <label className="builder_label">Aggregate Column</label>
        <div
          className="builder_displayBox"
          onClick={() => setIsModalOpen({ show: true, name: "Select Aggrigate Column" })}
        >
          <div>
            {column?.aggregate_column
              ? tableObj[column?.aggregate_column]?.prefix + "." + tableObj[column?.aggregate_column]?.display
              : "No field assign"}
          </div>
        </div>
      </div>
      <SingleSelectBox
        selectedData={column.aggregate_function}
        options={aggregateFunctionOptions}
        onChange={(obj) => handleChange("aggregate_function", obj.id)}
        placeholder="none"
        label="Aggregate Function"
      />
      {(column.aggregate_function === "sum_if" || column.aggregate_function === "count_if") && (
        <div className="flex_column gap_1">
          <CustomColumnGroupData
            field={column}
            handleChange={handleChangeInAggrigateFunction}
            allTableColumns={tableObj}
            tableId={tableId}
          />
        </div>
      )}
      <BuilderModal isOpen={isModalOpen.show} onClose={closeModal} modalName={isModalOpen.name}>
        <TableTreeModal
          callbackFunction={handleAggrigateColumn}
          tableId={tableId}
          selectedFile={column?.aggregate_column ? tableObj[column?.aggregate_column]?.id : ""}
        />
      </BuilderModal>
    </div>
  );
};
const EditButtonCustomColumn = ({ column, handleChangeColumn, tableId, tableType, device }) => {
  const { blockData } = useAppBlocksContext();
  const handleChangeList = (newList) => {
    handleChangeColumn({ ...column, config: newList });
  };
  return (
    <div>
      <ButtonListEditor
        list={JSON.parse(JSON.stringify(column.config))}
        onChange={handleChangeList}
        places="records_view_row"
        device={device}
        elements={[blockData]}
        positionClasses={true}
        tableId={tableId}
        tableType={tableType}
      />
    </div>
  );
};

export default EditCustomColumn;
